module.exports = __webpack_public_path__ + "static/img/20200503083322_62961.c699739.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/20200503083322_62961.jpg
// module id = wfCY
// module chunks = 73